import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  CUSTOMERS_PATH,
  CUSTOMER_DETAIL_ID_PATH,
  CUSTOMER_DETAIL_PATH,
} from "utils/constants/paths";

const Customers = Loadable(React.lazy(() => import("./View")));
const CustomerDetail = Loadable(React.lazy(() => import("./View/Detail")));

export const CustomersRoute: IRouteItem = {
  path: CUSTOMERS_PATH,
  iconName: "People",
  element: React.createElement(Customers),
  name: "Customers",
  accessKeys: ["SuperAdmin", "Admin", "Analytics", "Support"],
  children: [
    {
      name: "Detail",
      path: CUSTOMER_DETAIL_PATH,
      element: "",
      showInDrawer: false,
    },
    {
      path: CUSTOMER_DETAIL_ID_PATH,
      element: React.createElement(CustomerDetail),
      showInDrawer: false,
    },
  ],
};
